import { RootState } from '../reducers/rootReducer';

export const getSearchState = (state: RootState) => state.search;

export const getSearchSuggestionResult = (state: RootState) => getSearchState(state).suggestions;
export const getSearchIsLoading = (state: RootState) => getSearchState(state).loading;
export const getSearchResult = (state: RootState) => getSearchState(state).result;
